export enum actionTypes {
    SET_JACKPOTS = 'JACKPOTS:SET',
    SET_JACKPOTS_EYECON_FETCH = 'SET_JACKPOTS_EYECON_FETCH',
    SET_JACKPOTS_GAMES_GLOBAL_FETCH = 'SET_JACKPOTS_GAMES_GLOBAL_FETCH',
}
